import { simNaoEnumToBoolean } from 'components/form/field/SimNaoRadioGroupField'
import { EncerrarGestacaoInput, PreNatalInput, TipoGravidezEnum } from 'graphql/types.generated'

import { EncerrarGestacaoFormModel, PreNatalFormModel } from './model-preNatal'

export function convertPreNatalFormToInput(preNatalForm?: PreNatalFormModel): PreNatalInput {
  const isGravidezUnica = preNatalForm?.tipoGravidez?.value === TipoGravidezEnum.UNICA
  return (
    preNatalForm && {
      tipoGravidez: preNatalForm.tipoGravidez?.value,
      alturaUterina: preNatalForm.alturaUterina,
      edema: preNatalForm.edema,
      movimentacaoFetal: simNaoEnumToBoolean[preNatalForm.movimentacaoFetal],
      gravidezPlanejada: simNaoEnumToBoolean[preNatalForm.gravidezPlanejada],
      batimentoCardiacoFetal: preNatalForm.batimentoCardiacoFetal,
      batimentoCardiacoFetal2: isGravidezUnica ? null : preNatalForm.batimentoCardiacoFetal2,
      fonteIdadeGestacional: preNatalForm.fonteIdadeGestacional,
    }
  )
}

export function convertEncerrarGestacaoFormToInput(
  encerrarGestacaoForm?: EncerrarGestacaoFormModel
): EncerrarGestacaoInput {
  return (
    encerrarGestacaoForm && {
      tipoGravidez: encerrarGestacaoForm.tipoGravidez?.value,
      dataDesfecho: encerrarGestacaoForm.dataDesfecho,
    }
  )
}
